export const story = [
    {
      image:
        "https://images.unsplash.com/photo-1699800769230-02a5098e78c2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8aW5zdGElMjBwcm9maWxlJTIwcGljc3xlbnwwfHwwfHx8MA%3D%3D",
      username: "itz_julia",
      userId: 1,
    },
    {
      image:
        "https://images.unsplash.com/photo-1552497081-ab29f39b7757?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGluc3RhJTIwcHJvZmlsZSUyMHBpY3N8ZW58MHx8MHx8fDA%3D",
      username: "nikki",
      userId: 1,
    },
    {
      image:
        "https://images.unsplash.com/photo-1552644217-0a96ef16a2a5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8aW5zdGElMjBwcm9maWxlJTIwcGljc3xlbnwwfHwwfHx8MA%3D%3D",
      username: "mick01",
      userId: 1,
    },
    {
      image:
        "https://plus.unsplash.com/premium_photo-1707674002376-a736b180986d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8aW5zdGElMjBwcm9maWxlJTIwcGljc3xlbnwwfHwwfHx8MA%3D%3D",
      username: "btw_nancy",
      userId: 4,
    },
    {
      image:
        "https://plus.unsplash.com/premium_photo-1710364762890-8176083b84a2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8aW5zdGElMjBwcm9maWxlJTIwcGljc3xlbnwwfHwwfHx8MA%3D%3D",
      username: "iamnewt",
      userId: 5,
    },
  ];